module.exports = __webpack_public_path__ + "8756d25ad429cad904b061d9743b369b.glb";